/**
 * Angles (sorted) moved apart to at least `gap`, as little as possible.
 * Points are merged into clusters left to right; each cluster sits evenly
 * spaced around the mean of what its members wanted, and clusters that
 * then overlap merge again.
 */
export function spread(wanted: number[], gap: number): number[] {
  const clusters: Array<{ first: number; size: number; sum: number }> = []
  const start = (c: { size: number; sum: number }) =>
    c.sum / c.size - ((c.size - 1) * gap) / 2
  wanted.forEach((angle, i) => {
    clusters.push({ first: i, size: 1, sum: angle })
    while (clusters.length > 1) {
      const last = clusters[clusters.length - 1]
      const prev = clusters[clusters.length - 2]
      if (start(last) >= start(prev) + prev.size * gap - 1e-9) break
      clusters.pop()
      prev.size += last.size
      prev.sum += last.sum
    }
  })
  const out = new Array<number>(wanted.length)
  for (const c of clusters) {
    for (let k = 0; k < c.size; k++) out[c.first + k] = start(c) + k * gap
  }
  return out
}
